import { createSelector } from 'reselect';
import get from 'lodash/get';
import pagePayloadPayloadSelector from './pagePayloadPayload';

export default createSelector(pagePayloadPayloadSelector, pagePayloadPayload =>
  get(pagePayloadPayload, 'Components', [])
);
